import { buildApiUrl } from '@/config/api'

const TOKEN_KEY = 'auth_token'
const CURRENT_USER_KEY = 'current_user'

function clearLegacyAuthCache() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(CURRENT_USER_KEY)
}

function persistAuth(loginResponse) {
  const userText = JSON.stringify(loginResponse.user)
  sessionStorage.setItem(TOKEN_KEY, loginResponse.token)
  sessionStorage.setItem(CURRENT_USER_KEY, userText)
  clearLegacyAuthCache()
}

function readAuth() {
  clearLegacyAuthCache()
  return {
    token: sessionStorage.getItem(TOKEN_KEY),
    userText: sessionStorage.getItem(CURRENT_USER_KEY)
  }
}

export async function login(credentials) {
  try {
    const response = await fetch(buildApiUrl('/auth/login'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: credentials.username,
        password: credentials.password
      })
    })

    const data = await response.json()
    if (!response.ok || !data.success || !data.token || !data.user) {
      return {
        success: false,
        message: data.message || '用户名或密码错误'
      }
    }

    persistAuth(data)
    return {
      success: true,
      message: data.message || '登录成功',
      user: data.user,
      token: data.token
    }
  } catch (error) {
    console.error('登录请求失败:', error)
    return {
      success: false,
      message: '无法连接后端服务，请确认 E:\\demo\\5.19\\untitled 已启动'
    }
  }
}

export async function register(userData) {
  try {
    const response = await fetch(buildApiUrl('/auth/register'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: userData.username,
        password: userData.password,
        email: userData.email
      })
    })

    const data = await response.json()
    if (!response.ok || !data.success) {
      return {
        success: false,
        message: data.message || '注册失败'
      }
    }

    if (data.token && data.user) {
      persistAuth(data)
    }

    return {
      success: true,
      message: data.message || '注册成功'
    }
  } catch (error) {
    console.error('注册请求失败:', error)
    return {
      success: false,
      message: '无法连接后端服务，请确认 E:\\demo\\5.19\\untitled 已启动'
    }
  }
}

export function logout() {
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(CURRENT_USER_KEY)
  clearLegacyAuthCache()
}

export function isAuthenticated() {
  return !!getToken()
}

export function getCurrentUser() {
  const { userText } = readAuth()
  return userText ? JSON.parse(userText) : null
}

export function isAdmin() {
  const user = getCurrentUser()
  return !!user && user.role === 'admin'
}

export function getToken() {
  return readAuth().token
}

export async function changePassword() {
  return {
    success: false,
    message: '当前后端未提供修改密码接口'
  }
}
